<div class="w-full h-full pt-6 px-6 flex flex-col justify-start items-center overflow-auto">
  <div class="w-full max-w-xl flex flex-col justify-start items-center gap-6 pb-10">
    <app-back-header (backClicked)="dialogRef.close()"/>
    <app-icon-badge-header
      svgIcon="ph-regular-users"
      titleKey="components.faq.contact_modal.title"
      [subtitleBoldKey]="isLogged ? 'components.faq.contact_modal.subtitle_bold' : null"
      [subtitleLightKey]="isLogged ? 'components.faq.contact_modal.subtitle_light' : null"
    />
    <!-- Help Form -->
    <form [formGroup]="helpForm" class="w-full flex flex-col gap-4">
      <div class="w-full bg-card-background border border-solid border-default-dark rounded p-4 flex flex-col gap-4">
        <mat-form-field *ngIf="!this.isLogged" class="w-full" appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-label> {{ 'common.forms.email.label' | translate }} </mat-label>
          <input matInput type="text" formControlName="email" placeholder="john.doe@example.com">
        </mat-form-field>
        <mat-form-field class="w-full" appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-label> {{ 'components.faq.contact_modal.category' | translate }} </mat-label>
          <mat-select formControlName="category" (selectionChange)="onCategoryChange($event.value)">
            <mat-select-trigger *ngIf="helpForm.get('category')?.value" class="flex items-center gap-2">
              <mat-icon [svgIcon]="categoryIcons[helpForm.get('category')?.value]" class="shrink-0"></mat-icon>
              <span>{{ categoriesDict[helpForm.get('category')?.value] }}</span>
            </mat-select-trigger>
            <mat-option *ngFor="let category of categories" [value]="category">
              <mat-icon [svgIcon]="categoryIcons[category]" class="mr-1 shrink-0"></mat-icon>
              {{ categoriesDict[category] }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Transaction Selection (shown conditionally) -->
        <mat-form-field *ngIf="shouldShowTransactionSelector" class="w-full" appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-label>{{ 'components.faq.contact_modal.transaction_label' | translate }}</mat-label>
          <mat-select formControlName="transaction">
            <mat-option *ngFor="let transaction of recentTransactions" [value]="transaction">
              {{ formatTransactionOption(transaction) }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="loadingTransactions" class="flex items-center gap-2">
            <mat-spinner [color]="'primary'" diameter="16"></mat-spinner>
            <span class="text-light-gray">Cargando transacciones...</span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field class="w-full" appearance="outline" [subscriptSizing]="'dynamic'">
          <textarea matInput type="text" formControlName="message" placeholder="Cuéntanos lo que pasó aquí. *"></textarea>
        </mat-form-field>

        <!-- Transaction Not Found Helper (shown after the message field) -->
        <div *ngIf="shouldShowTransactionSelector && !preSelectedTransaction && !loadingTransactions"
             class="w-full p-3 bg-blue-50 border border-solid border-blue-200 rounded-lg flex items-start gap-2">
          <mat-icon svgIcon="ph-regular-info" class="icon-xxsm text-blue-600 shrink-0"></mat-icon>
          <p class="text-sm text-blue-700 m-0">
            {{ 'components.faq.transaction_hint' | translate }}
            <a class="underline cursor-pointer" (click)="navigateToHistory()">{{ 'components.faq.transaction_hint_link' | translate }}</a>
          </p>
        </div>

        <!-- Image Upload Section -->
        <div class="w-full flex flex-col items-center gap-2" *ngIf="isLogged">
          <p class="font-semibold text-default-gray text-center m-0">{{ 'components.faq.photos_title' | translate }}</p>
          <p *ngIf="!areImagesRequired" class="text-light-gray text-sm text-center m-0">{{ 'components.faq.photos_optional' | translate }}</p>
          <p *ngIf="areImagesRequired && images.length === 0" class="text-error text-sm text-center m-0">{{ 'components.faq.photos_required_error' | translate }}</p>
          <app-underline-button
            svgIcon="ph-regular-camera"
            [disabled]="images.length >= maxImages"
            (pressed)="openTakePictureDialog()">
            {{ 'components.issues.issue.add_response.take_photo' | translate }}
          </app-underline-button>
          <!-- Image Preview -->
          <div *ngIf="images.length > 0" class="w-full">
            <div class="grid grid-cols-3 gap-2">
              <div *ngFor="let image of images; let i = index" class="relative">
                <img
                  [src]="image.preview"
                  [alt]="'Imagen ' + (i + 1)"
                  class="w-full h-20 object-cover rounded border"
                >
                <button
                  type="button"
                  mat-icon-button
                  color="warn"
                  (click)="removeImage(i)"
                  class="absolute"
                >
                  <mat-icon svgIcon="ph-regular-x-square"></mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full flex justify-center items-center gap-3">
        <button [disabled]="helpForm.invalid" mat-raised-button color="primary" class="w-full" (click)="onSendHelp()">{{ 'components.faq.contact_modal.submit' | translate }}</button>
      </div>
    </form>
  </div>
</div>
